import React, { FC } from 'react';
import { GxTabPanel } from '@garpix/garpix-web-components-react';
import PayOrderPanelTable from './PayOrderPanelTable';


import 'react-responsive-modal/styles.css';
import styles from '../../styles/index.module.scss';

const PayOrderPanel: FC<{ userId: number }> = ({ userId }) => (
  <GxTabPanel name='payOrder'>
    <div className={styles['payOrder']}>
      <PayOrderPanelTable userId={userId} />
    </div>
  </GxTabPanel>
);

export default PayOrderPanel;
